import ahoy from 'ahoy.js';

import Swiper from 'swiper';
import '@iconfu/svg-inject'
import 'isotope-layout'
import './theme';

$.ahoy = ahoy;
